import MySearch from '../MySearch';
import MySelect from '../MySelect';

export default {
    components: { MySearch, MySelect },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedValue: '',
            valueForFilter: '',
            amountForShow: 10,
            iterationShowRange: 10,
            filteredList: false
        };
    },
    computed: {
        listForDisplay() {
            console.log(this.data);
            return this.filteredList ? this.filteredList : this.makeCopyOfList();
        },
        cutList() {
            return this.listForDisplay.slice(0, this.amountForShow);
        },
        isShowMoreButton() {
            return this.listForDisplay.length > this.amountForShow;
        }
    },
    watch: {
        valueForFilter() {
            this.makeFilteredList();
        },
        selectedValue() {
            this.makeFilteredList();
        }
    },
    methods: {
        makeCopyOfList() {
            return JSON.parse(JSON.stringify(this.data.list));
        },
        resetAmountForShow() {
            this.amountForShow = this.iterationShowRange;
        },
        showMoreItems() {
            this.amountForShow += this.iterationShowRange;
        },
        setValueForFilter(value) {
            this.valueForFilter = value;
            this.resetAmountForShow();
        },
        setSelectValue({ value }) {
            if (!this.data.selectOptions.length) { return false; }
            if (this.data.selectOptions[0].value === value) {
                this.selectedValue = '';
            } else {
                this.selectedValue = value;
            }
            this.resetAmountForShow();
        },
        filterForSelect(list) {
            return list.filter((item) => item.type === this.selectedValue);
        },
        filterForSearch(list) {
            return list.filter((item) => item.title.toLowerCase().includes(this.valueForFilter.toLowerCase()));
        }
    }
};
